<template>
    <div style="border-bottom: solid 1px #ededed;">
        <div style="display: table;">
            <img :src="imgSrc" @click="buttonClick" :class="[this.iconSrc == null ? 'back-btn' : 'logo']"/>
            <span style="position: relative; float: left; margin-top: 19px; font-weight: 600">{{text}}</span>
        </div>

        <span style="display: table-cell; position: absolute; right: 16px; margin-top: 16px; font-size: 14px; font-weight: 600;" @click="itemClick">{{itemText}}</span>

        <slot/>
    </div>
</template>

<script>
    export default {
        name: "app_bar",
        props: {
            itemText: String,
            text: String,
            iconSrc: String
        },
        data() {
            return {
                imgSrc: ''
            }
        },
        methods: {
            buttonClick() {
                this.$emit("onBack")
            },
            itemClick() {
                this.$emit("onClickItem")
            }
        },
        beforeMount() {

            if (this.iconSrc != null) {
                this.imgSrc = this.iconSrc
            } else {
                this.imgSrc = './assets/btn_back.png';
            }
        }
    }
</script>

<style scoped>
    div {
        position: fixed;
        height: 50px;
        background-color: white;
        z-index: 200;
        margin: 0;
        padding: 0;
        max-width: 1024px;
    }

    .back-btn {
        top : 0;
        left: 0;
        position: absolute;
        width: 12px;
        height: 20px;
        margin: 1rem;
        cursor: pointer;
        z-index: 10000;
    }

    .logo {
        position: relative;
        height: 32px;
        cursor: pointer;
        float: left;
        margin-top: 10px;
        margin-left: 10px;
    }
</style>